import intlTelInput from 'intl-tel-input';
import * as util from './util';

const BookingFailedPage = function($root) {
    this.$root = $root;

    const $form = $root.find('.retry-form');

    jQuery("#BookingTryAgain").click(function (e) {
        e.preventDefault();

        jQuery('#BookingTryAgain').html('LOADING');

        jQuery.ajax({
            url: $form.attr('action'),
            data: $form.serialize(),
            type: $form.attr('method'),
            success: function(response) {
                const data = response.data;
                var form = document.createElement("form");
                form.setAttribute("method", "POST");
                form.setAttribute("name", "booknow");
                form.setAttribute("action", data.cybersource.url);

                for (let key in data.cybersource.params) {
                    let value = data.cybersource.params[key];
                    let hiddenField = document.createElement("input");
                    hiddenField.setAttribute("type", "hidden");
                    hiddenField.setAttribute("name", key);
                    hiddenField.setAttribute("value", value);
                    form.appendChild(hiddenField);
                }

                document.body.appendChild(form);
                form.submit();
            },
            error: function(data) {
              $("#mytext").html('Unknown error. Please try again later or contact via info@sooriya.com (Error #: 101)');
              $("#myModal").modal('show');
            }
        });
    });
};

export default BookingFailedPage;